import React from 'react';

const KnowledgeCenter: React.FC = () => (
  <div className="static-page">
    <h1>Knowledge Center</h1>
    <p>Access resources, articles, and information about U.S. immigration law, green card categories, and the latest updates. Our Knowledge Center is designed to help you stay informed and make the best decisions for your case.</p>
  </div>
);

export default KnowledgeCenter;
